import React from "react";
import { Route, Routes } from "react-router-dom";
import FreeUnloadingCreateScreen from "screens/App/CRM/ShipmentUnLoading/FreeUnloadingCreateScreen";
import ShipmentUnLoadingCreateScreen from "screens/App/CRM/ShipmentUnLoading/ShipmentUnLoadingCreateScreen";
import ShipmentUnLoadingDetailScreen from "screens/App/CRM/ShipmentUnLoading/ShipmentUnLoadingDetailScreen";
import ShipmentUnLoadingEditScreen from "screens/App/CRM/ShipmentUnLoading/ShipmentUnLoadingEditScreen";
import ShipmentUnLoadingListScreen from "screens/App/CRM/ShipmentUnLoading/ShipmentUnLoadingListScreen";
import NotFoundScreen from "screens/NotFoundScreen";

const ShipmentUnLoadingRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<ShipmentUnLoadingCreateScreen />} />

      <Route path="list" element={<ShipmentUnLoadingListScreen />} />

      <Route path=":id/detail" element={<ShipmentUnLoadingDetailScreen />} />

      <Route path=":id/edit" element={<ShipmentUnLoadingEditScreen />} />

      <Route path="create-free-Unloading" element={<FreeUnloadingCreateScreen />} />

      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default ShipmentUnLoadingRouter;
